/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCandleFilled = createReactComponent("filled", "candle-filled", "IconCandleFilled", [["path", { "d": "M14 10h-4a2 2 0 0 0 -2 2v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-9a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11.254 2.334l-1.55 1.737c-1.042 1.277 -.898 3.097 .296 4.166a3 3 0 0 0 4.196 -4.28l-1.452 -1.624a1 1 0 0 0 -1.491 .001z", "key": "svg-1" }]]);

export { IconCandleFilled as default };
//# sourceMappingURL=IconCandleFilled.mjs.map
